import { Action } from '@ngrx/store';

export enum EPortabilityDatesActions {
  GetPortabilityDates = '[PORTABILITY_DATES] Get portability dates',
  GetPortabilityDatesSuccess = '[PORTABILITY_DATES] Get portability dates success',
  GetPortabilityDatesFailure = '[PORTABILITY_DATES] Get portability dates failure',
}

/**
 * Get portability dates action and state to save in store
 */
export class GetPortabilityDates implements Action {
  public readonly type = EPortabilityDatesActions.GetPortabilityDates;
}

/**
 * Get portability dates success action and state to save in store
 */
export class GetPortabilityDatesSuccess implements Action {
  public readonly type = EPortabilityDatesActions.GetPortabilityDatesSuccess;
  constructor(public payload: Array<string>) {}
}

/**
 * Get portability dates failure action and state to save in store
 */
export class GetPortabilityDatesFailure implements Action {
  public readonly type = EPortabilityDatesActions.GetPortabilityDatesFailure;
}

/**
 * Export actions : will be used in reducers
 */
export type PortabilityDatesActions = GetPortabilityDates | GetPortabilityDatesSuccess | GetPortabilityDatesFailure;
